const KEY = 'auth.refresh.lock';
const TTL_MS = 10_000;
export function tryAcquireRefreshLock() {
    try {
        const now = Date.now();
        const raw = localStorage.getItem(KEY);
        if (raw) {
            try {
                const { until } = JSON.parse(raw);
                if (typeof until === 'number' && until > now)
                    return false;
            }
            catch {
                // corrupted; ignore
            }
        }
        localStorage.setItem(KEY, JSON.stringify({ until: now + TTL_MS }));
        return true;
    }
    catch {
        return true; // best-effort: if storage broken, don't block
    }
}
export function releaseRefreshLock() {
    try {
        const raw = localStorage.getItem(KEY);
        if (raw) {
            const { until } = JSON.parse(raw);
            if (typeof until === 'number' && until <= Date.now()) {
                // already expired; leave it
                return;
            }
        }
        localStorage.removeItem(KEY);
    }
    catch {
        // ignore
    }
}
//# sourceMappingURL=auth-locks.js.map